import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CaseManagementService } from '../../../case-management/case-management.service';

@Component({
  selector: 'app-case-creation-dialog',
  templateUrl: './case-creation-dialog.component.html',
  styleUrls: ['./case-creation-dialog.component.scss'],
  standalone: false,
})
export class CaseCreationDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<CaseCreationDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  private cms = inject(CaseManagementService);

  repCode = null;
  repName = null;
  repCodeValue = null;
  repCodeControl = new FormControl();
  caseUsers = [];
  allRepCodes = [];

  caseAlerts = [];

  ngOnInit(): void {
    if (this.data.amlMode) {
      this.caseAlerts.push(this.data.alerts[0].name);
    }

    this.cms.getCaseManagementUsers(this.data.tradeRep).subscribe(resp => {
      const newUsersList = resp['Users'].map(user => ({
        value: user.UserID,
        display: user.UserName,
      }));
      this.caseUsers = newUsersList;
      this.allRepCodes = newUsersList;
    });

    this.repCodeControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.caseUsers = this.caseUsers.filter(
            user =>
              user['value'].toLowerCase().includes(value.toLowerCase()) ||
              user['display'].toLowerCase().includes(value.toLowerCase())
          );
        } else {
          this.caseUsers = this.allRepCodes;
        }
      });
  }

  setRepCode(ev) {
    const {
      option: { value },
    } = ev;
    this.repCode = value;
    this.repName = this.caseUsers.find(user => user.value === value).display;
    this.repCodeValue = this.caseUsers.find(user => user.value === value).value;
  }

  toggleAlert(ev, alert) {
    if (ev.checked && !this.caseAlerts.includes(alert.name)) {
      this.caseAlerts.push(alert.name);
    } else if (!ev.checked && this.caseAlerts.includes(alert.name)) {
      const alertIndex = this.caseAlerts.findIndex(
        caseAlert => caseAlert === alert.name
      );
      this.caseAlerts.splice(alertIndex, 1);
    }
  }

  confirmCaseCreation() {
    this.dialogRef.close({
      action: 'continue',
      caseAlerts: this.caseAlerts,
      assignedTo: this.repCodeValue,
      repName: this.repName,
    });
  }
}
